import React, { useRef, useState, useEffect, useContext } from 'react'
import { 
    Container,
    HeaderDiv,
    HeaderText,
    CloseDiv,
    CloseImg,
    OptionTabDiv,
    OptionImg,
    OptionTextDiv,
    OptionMainText,
    OptionSubText,
    ArrowImg,
    CancelButton
 } from './style'
import ModalContext from '../../contexts/ModalContext'
import signIn from '../../assets/addStockModal/sign-in.svg'
import arrow from '../../assets/addStockModal/arrow-right.svg'
import keyboard from '../../assets/addStockModal/keyboard.svg'
import cross from '../../assets/addStockModal/cross.svg'
import StockContext from '../../contexts/StockContext'

 const AddStockMenu: React.FC = () => {
    const { setModalActive, setModalSection, setItIsUpdate } = useContext(ModalContext)

    const clickAddStock = () => {
        setItIsUpdate(false)
        setModalSection('firstCustomAdd')
    }

    return (
        <Container>
            <HeaderDiv>
                <HeaderText>Adicionar estoque</HeaderText>
                <CloseDiv onClick={() => setModalActive(false)}>
                    <CloseImg src={cross} alt='Close tab'/>
                </CloseDiv>
            </HeaderDiv>
            <OptionTabDiv onClick={() => setModalSection('firstExcelAdd')}>
                <OptionImg src={signIn} alt='Sign-in Icon'/>
                <OptionTextDiv>
                    <OptionMainText>Importar tabela</OptionMainText>
                    <OptionSubText>A partir do upload de um arquivo local</OptionSubText>
                </OptionTextDiv>
                <ArrowImg src={arrow} alt='Arrow icon'/>
            </OptionTabDiv>
            <OptionTabDiv onClick={() => clickAddStock()}>
                <OptionImg src={keyboard} alt='Keyboard icon'/>
                <OptionTextDiv>
                    <OptionMainText>Adicionar manualmente</OptionMainText>
                    <OptionSubText>Insira os dados de forma customizada</OptionSubText>
                </OptionTextDiv>
                <ArrowImg src={arrow} alt='Arrow icon'/>
            </OptionTabDiv>
            <CancelButton onClick={() => setModalActive(false)}>Cancelar</CancelButton>
        </Container>
    )
}

export default AddStockMenu